import Request from './request';
import consts from "@/consts";

async function fetch(data) {
    return Request('get', "api/third-account-info/index", data);
}

async function fetchAll(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/third-account-info/index", data);
}

async function fetchOne(id) {
    return Request('get', "api/third-account-info/view/" + id);
}

async function fetchAllForSelect(data) {
    return Request('get', "api/third-account-info/supplier-list", data);
}

async function getHuifuPayRecordList(data) {
    return Request('get', "api/third-account-info/third-pay-records", data);
}

async function getHuifuCashRecordList(data) {
    return Request('get', "api/third-account-info/third-cash-records", data);
}

async function addHfdgBalancePay(data) {
    return Request('post', "api/third-account-info/add-hfdg-balance-pay", data);
}

async function addHfdgEnchashment(data) {
    return Request('post', "api/third-account-info/add-hfdg-enchashment", data);
}

async function mobileValidation(data) {
    return Request('post', "api/third-account-info/mobile-validation", data);
}

async function addHfdgReturnBalance(data) {
    return Request('post', "api/third-account-info/add-hfdg-return-balance", data);
}

async function addLklUser(data) {
    return Request('post', 'api/third-account-info/add-lkl-user', data)
}

async function editLklUser(data) {
    return Request('post', 'api/third-account-info/edit-lkl-info', data)
}

async function addLklBalancePay(data) {
    return Request('post', "api/third-account-info/add-lkl-balance-pay", data);
}

async function addLklEnchashment(data) {
    return Request('post', "api/third-account-info/add-lkl-enchashment", data);
}

async function addLklReturnBalance(data) {
    return Request('post', "api/third-account-info/add-lkl-return-balance", data);
}

async function indexForLkl(data) {
    return Request('get', "api/third-account-info/index-for-lkl", data);
}

async function indexAllForLkl(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/third-account-info/index-for-lkl", data);
}

async function thirdPayRecordsForLkl(data) {
    return Request('get', "api/third-account-info/third-pay-records-for-lkl", data);
}

async function thirdCashRecordsForLkl(data) {
    return Request('get', "api/third-account-info/third-cash-records-for-lkl", data);
}

async function deleteAccount(id) {
    return Request('get', "api/third-account-info/delete-hfdg-account/" + id);
}



export default {
    fetch,
    fetchAll,
    fetchOne,
    fetchAllForSelect,
    getHuifuPayRecordList,
    getHuifuCashRecordList,
    addHfdgBalancePay,
    addHfdgEnchashment,
    mobileValidation,
    addHfdgReturnBalance,
    addLklUser,
    editLklUser,
    addLklBalancePay,
    addLklEnchashment,
    addLklReturnBalance,
    indexForLkl,
    indexAllForLkl,
    thirdPayRecordsForLkl,
    thirdCashRecordsForLkl,
    deleteAccount,
};